import { render, staticRenderFns } from "./BulkRegistrationList.vue?vue&type=template&id=51f3a4f0&scoped=true&"
import script from "./BulkRegistrationList.vue?vue&type=script&lang=js&"
export * from "./BulkRegistrationList.vue?vue&type=script&lang=js&"
import style0 from "./BulkRegistrationList.vue?vue&type=style&index=0&id=51f3a4f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3a4f0",
  null
  
)

export default component.exports